"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Discussion = babelHelpers.interopRequireDefault(require("./Discussion"));

var PeopleGroupDiscussionTab =
/*#__PURE__*/
function (_DiscussionTab) {
  babelHelpers.inherits(PeopleGroupDiscussionTab, _DiscussionTab);

  function PeopleGroupDiscussionTab() {
    babelHelpers.classCallCheck(this, PeopleGroupDiscussionTab);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PeopleGroupDiscussionTab).apply(this, arguments));
  }

  babelHelpers.createClass(PeopleGroupDiscussionTab, null, [{
    key: "getTrackData",
    value: function getTrackData(object, page, tab) {
      return {
        accountGroup: object.id
      };
    }
  }, {
    key: "value",
    value: function value(object, page, tab) {
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(PeopleGroupDiscussionTab), "value", this).call(this, object, page, tab);
      if (r) r.type = 'tab/PeopleGroupDiscussion';
      return r;
    }
  }]);
  return PeopleGroupDiscussionTab;
}(_Discussion.default);

exports.default = PeopleGroupDiscussionTab;